import React from 'react';
import HeroSection from '../components/HeroSection';
import WelcomeSection from '../components/WelcomeSection';
import Services from '../components/Services';
import TestimonialsSection from '../components/TestimonialsSection';
import { Box } from '@mui/material';

const Home = () => {
    return (
        <Box>
            <HeroSection />
            <WelcomeSection />
            <Services />
            <TestimonialsSection />
        </Box>
    );
};

export default Home;
